import type {
  SurveyQuestion,
  SurveyQuestionWithEditMeta,
} from '../dtos/survey.dto'

/**
 * Whether a survey question counts as "active" for organizers/participants.
 * Missing or `undefined` `active` is treated as active; only explicit `active: false` is inactive.
 */
export function isSurveyQuestionActive(
  q: SurveyQuestion | SurveyQuestionWithEditMeta
): boolean {
  return !('active' in q) || q.active !== false
}

/** True if at least one question in the list is active (see {@link isSurveyQuestionActive}). */
export function hasActiveQuestion(
  questions: ReadonlyArray<SurveyQuestion | SurveyQuestionWithEditMeta>
): boolean {
  return questions.some(isSurveyQuestionActive)
}
